import React, { Component } from "react";

import DoctorDetailView from "./DoctorDetailView";

import {
  openNotificationWithIcon,
  strings,
  history,
  Loader
} from "../../../helpers";
import { updateClinicDoctor, getClinicDoctorDetail } from "../../../services";

class DoctorsDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clinicId: null,
      doctorId: "",
      isProcessing: false,
      fees: "",
      showEditFeeInput: false,
      showEditPatientCountInput: false,
      patientsPerHour: "",
      doctorsDetail: "",
      updateProcessing: false,
      currentPage: null,
      displayPhotos: [],
      showPrompt: false,
      telemedicineSetupStatus: false,
      showTelemedSucessModal: false,
      gifSection: true,
      accountSection: false,
      regPhotoUrl: null,
      teleBankAccountTitle: false,
      teleBankDescription: false

      // photos: [],
      // imageUrl: ""
    };
  }

  componentDidMount() {
    const { clinicId } = this.props;

    this.getDetail();
    const pathName = window.location.pathname;
    let currentPage = null;
    const pathStr = (pathName.match(new RegExp("/", "g")) || []).length;
    if (pathStr === 1) {
      currentPage = pathName.replace("/", "");
    } else if (pathStr === 2 || pathStr === 3 || pathStr === 4) {
      currentPage = pathName.substring(1).split("/")[0];
    } else if (pathStr === 5) {
      currentPage = pathName.substring(1).split("/")[pathStr - 1];
    }
    this.setState({ currentPage, clinicId });
  }

  /**
   * @function isTelemedicineSetupComplete
   * @desc This function will check the telemedicine status
   */
  isTelemedicineSetupComplete = doctorObj => {
    let setupComplete = false;

    let regNo = doctorObj.doctor_details.reg_nbr;
    regNo = regNo ? regNo.trim() : null;
    let education = doctorObj.doctor_details.education;
    education = education ? education.trim() : null;
    let telemedicineFees = doctorObj.doctor_details.telemedicine_fees;
    telemedicineFees = telemedicineFees || null;

    if (education && regNo && telemedicineFees) {
      setupComplete = true;
    }
    return setupComplete;
  };

  /**
   * @function updateDoctorCertificate
   * @desc This function will update uploaded certificate in the state variable
   */
  updateDoctorCertificate = url => {
    this.setState({ regPhotoUrl: url });
  };

  /**
   * @function getDetail
   * @desc This function handles getting doctor detail
   */
  getDetail = () => {
    const { clinicId, clinicDocId } = this.props;

    this.setState({ clinicDocId, isProcessing: true });

    getClinicDoctorDetail(clinicId, clinicDocId).then(response => {
      if (response.data && response.data.success) {
        const doctorsDetail = response.data.data;
        this.setState({
          isProcessing: false,
          updateProcessing: false,
          doctorsDetail,
          telemedicineSetupStatus: doctorsDetail.telemedicine_setup,
          regPhotoUrl: doctorsDetail.doctor.reg_photo_url
        });
        if (doctorsDetail.photo) {
          this.getImageData([doctorsDetail.photo]);
        }
        if (doctorsDetail.schedules && doctorsDetail.schedules.length === 0) {
          this.setState({
            showPrompt: true
          });
        } else if (
          doctorsDetail.schedules &&
          doctorsDetail.schedules.length > 0
        ) {
          this.setState({
            showPrompt: false
          });
        }
      }
    });
  };

  /**
   * @function handleChange
   * @desc This function handles input change
   */
  handleChange = elem => {
    const { name, value } = elem.target;
    this.setState({
      [name]: value.replace(/\s/g, "")
    });
  };

  /**
   * @function toggleAddFeeView
   * @desc This function handles toggling of fees input
   */
  toggleAddFeeView = () => {
    const { doctorsDetail } = this.state;

    this.setState(prevState => ({
      showEditFeeInput: !prevState.showEditFeeInput,
      fees: doctorsDetail.fees
    }));
  };

  /**
   * @function updateDoctorFees
   * @desc This function handles doctor fees updation
   */
  updateDoctorFees = () => {
    const typeOfInfo = "fees";
    const { fees } = this.state;
    if (fees && fees != 0) {
      const feesObj = {
        doctor_details: {
          fees: parseInt(fees, 10)
        }
      };
      this.updateDoctorInfo(feesObj, typeOfInfo);
    }
  };

  /**
   * @function updatePatientsPerHour
   * @desc This function handles updation of patients per hour count
   */
  updatePatientsPerHour = () => {
    const typeOfInfo = "patientsPerHour";
    const { patientsPerHour } = this.state;
    const doctorObj = {
      doctor_details: {
        patients_per_hour: parseInt(patientsPerHour, 10)
      }
    };
    this.updateDoctorInfo(doctorObj, typeOfInfo);
  };

  /**
   * @function updateDoctorInfo
   * @desc This function handles doctor info update
   */
  updateDoctorInfo = (doctorObj, typeOfInfo) => {
    const { regPhotoUrl } = this.state;
    const { clinicDocId } = this.props;

    doctorObj.doctor_details.reg_photo_url = regPhotoUrl;

    if (!doctorObj.doctor_details.name.trim()) {
      openNotificationWithIcon("error", "Name", "Please enter name");
      return;
    }

    if (
      doctorObj &&
      doctorObj.doctor_details &&
      doctorObj.doctor_details.telemedicine_fees == ""
    ) {
      doctorObj.doctor_details.telemedicine_fees = null;
    }

    this.setState({ updateProcessing: true });
    const { clinicId, doctorId, telemedicineSetupStatus } = this.state;
    updateClinicDoctor(clinicId, clinicDocId, doctorObj).then(response => {
      if (response.data && response.data.success) {
        openNotificationWithIcon(
          "success",
          "Update doctor",
          "Doctor updated successfully"
        );
        // if(!telemedicineSetupStatus && this.isTelemedicineSetupComplete(doctorObj)){
        //   this.toggleTeleSuccessModal();

        // }
        // else{
        //   openNotificationWithIcon(
        //     "success",
        //     strings.doctors.updateDoctor,
        //     strings.doctors.updateDoctorSuccess
        //   );
        // }
        if (typeOfInfo === "fees") this.toggleAddFeeView();
        else this.togglePatientPerHourInput();
        this.getDetail();
        // if telemedicine setup is false
        // if (!this.props.telemedicineSetup) {
        //   this.getClinicSettings(clinicId);
        // }
      } else {
        openNotificationWithIcon(
          "error",
          "Update fees",
          "There was some error while processing your request"
        );
      }
    });
  };

  /**
   * @function togglePatientPerHourInput
   * @desc This function toggles patient per hour input
   */
  togglePatientPerHourInput = () => {
    const { doctorsDetail } = this.state;
    this.setState(prevState => ({
      showEditPatientCountInput: !prevState.showEditPatientCountInput,
      patientsPerHour: doctorsDetail.doctor.patients_per_hour
    }));
  };

  /**
   * @function goToDoctorList
   * @desc This function allows user to go to doctor list page
   */
  goToDoctorList = () => {
    history.push("/settings/users/doctors");
  };

  /**
   * @func getImageData
   * @param data
   * @description it will get the image data
   */
  getImageData = photos => {
    if (photos.length > 0) {
      const tempArr = [];
      const finalPhotosArray = [];

      photos.map((element, index) => {
        const obj = {
          uid: index,
          name: element,
          status: "done",
          url: element,
          id: index
        };
        tempArr.push(obj);
      });

      photos.map((element, index) => {
        const obj = {
          photo_url: element,
          id: index
        };
        finalPhotosArray.push(obj);
      });

      this.setState({
        // photos: finalPhotosArray,
        displayPhotos: tempArr
        // imageUrl: photos[0]
      });
    } else {
      this.setState({
        // photos: [],
        displayPhotos: []
        // imageUrl: ""
      });
    }
  };

  /**
   * @func toggleTeleSuccessModal
   * @description this will toggle the modal
   */
  toggleTeleSuccessModal = () => {
    this.setState({
      showTelemedSucessModal: !this.state.showTelemedSucessModal
    });
  };
  /**
   * @func updateDoctorCertificateState
   * @description this will update regphotoUrl
   */
  updateDoctorCertificateState = () => {
    this.setState({ regPhotoUrl: null });
  };

  handleTelemedicineSteps = () => {
    this.setState({
      teleBankAccountTitle: true,
      teleBankDescription: true,
      gifSection: false,
      accountSection: true
    });
  };

  handleManageAccount = () => {
    this.setState({ showTelemedSucessModal: false });
    // const billingAppUrl = `${process.env.REACT_APP_BILLING_SITE_BASE_URL}/change-plan/nav`;
    // window.open(billingAppUrl, "_blank");
    history.push(`/billing-plans`);
  };

  render() {
    const {
      doctorsDetail,
      fees,
      showEditFeeInput,
      showEditPatientCountInput,
      patientsPerHour,
      isProcessing,
      updateProcessing,
      displayPhotos,
      showPrompt,
      showTelemedSucessModal,
      gifSection,
      accountSection,
      regPhotoUrl,
      teleBankAccountTitle,
      teleBankDescription
      // photos,
      // imageUrl
    } = this.state;
    return (
      <div>
        {isProcessing && !updateProcessing && <Loader />}
        {doctorsDetail && (
          <>
            <DoctorDetailView
              updateDoctorInfo={this.updateDoctorInfo}
              doctorsDetail={doctorsDetail}
              fees={fees}
              showEditFeeInput={showEditFeeInput}
              handleChange={this.handleChange}
              toggleAddFeeView={this.toggleAddFeeView}
              updateDoctorFees={this.updateDoctorFees}
              togglePatientPerHourInput={this.togglePatientPerHourInput}
              showEditPatientCountInput={showEditPatientCountInput}
              patientsPerHour={patientsPerHour}
              updatePatientsPerHour={this.updatePatientsPerHour}
              isProcessing={isProcessing}
              goToDoctorList={this.goToDoctorList}
              updateProcessing={updateProcessing}
              getDetail={this.getDetail}
              displayPhotos={displayPhotos}
              getImageData={this.getImageData}
              updateDoctorCertificate={this.updateDoctorCertificate}
              regPhotoUrl={regPhotoUrl}
              updateDoctorCertificateState={this.updateDoctorCertificateState}
              clinicId={this.props.clinicId}
            />
          </>
        )}
      </div>
    );
  }
}

export default DoctorsDetailContainer;
